import { render, staticRenderFns } from "./_SearchGuidelinesModal.vue?vue&type=template&id=040f5e96&scoped=true&"
import script from "./_SearchGuidelinesModal.vue?vue&type=script&lang=js&"
export * from "./_SearchGuidelinesModal.vue?vue&type=script&lang=js&"
import style0 from "./_SearchGuidelinesModal.vue?vue&type=style&index=0&id=040f5e96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f5e96",
  null
  
)

export default component.exports